// extracted by mini-css-extract-plugin
export default {"container":"_9fe39c4e","closed":"_b60127db","price":"_c5f29184","link":"_2c28ae9"};